// Web stub for react-native-worklets
// Exports no-op versions of functions that react-native-reanimated imports

const noop = () => {};
const noopReturn = (v) => v;

export const runOnUISync = noop;
export const scheduleOnUI = noop;
export const scheduleOnRN = noop;
export const createSerializable = noopReturn;
export const createSynchronizable = noopReturn;
export const serializableMappingCache = new Map();
export const WorkletsModule = {};
export const callMicrotasks = noop;
export const RuntimeKind = { UI: 'UI', RN: 'RN' };
export const isWorkletFunction = () => false;
export const makeShareable = noopReturn;
export const createWorkletRuntime = noop;
export const executeOnUIRuntimeSync = noop;
export const runOnJS = noopReturn;
export const runOnUI = noopReturn;
export const runOnRuntime = noopReturn;

export default {
  runOnUISync,
  scheduleOnUI,
  scheduleOnRN,
  createSerializable,
  createSynchronizable,
  serializableMappingCache,
  WorkletsModule,
  callMicrotasks,
  RuntimeKind,
  isWorkletFunction,
  makeShareable,
  createWorkletRuntime,
  executeOnUIRuntimeSync,
  runOnJS,
  runOnUI,
  runOnRuntime,
};
